<template>
  <div class="actions-dropdown">
    <b-dropdown
      no-caret
      class="d-none d-lg-block"
      variant="link"
      :toggle-class="`text-decoration-none shadow-none ${toggleClass}`"
      :content-class="`outline-none shadow-none ${contentClass}`"
      :left="left"
      :right="right"
      :disabled="disabled"
    >
      <template #button-content>
        <slot name="button-custom-content" v-bind:item="item">
          <i
            class="icon-more-vertical btn btn-sm btn-square-sm default-icon"
            role="button"
          ></i>
        </slot>
      </template>
      <b-dropdown-item
        v-for="(action, index) in actions"
        :key="index"
        @click.stop="onClickItem(action, index)"
        class="my-3"
      >
        <small class="align-items-center" :class="action.class">
          <i v-if="action.icon" :class="action.icon"></i>
          <span v-html="action.text"></span>
        </small>
        <confirmation
          v-if="action.confirmation.enable"
          iconType="warning"
          title="Aviso"
          cancelButtonText="Cancelar"
          :showCancelButton="action.confirmation.showCancelButton"
          v-model="visible[index]"
          :newDesign="action.confirmation.newDesign"
          :confirmButtonClass="action.confirmation.submitButtonClass"
          :confirmButtonText="action.confirmation.submitText"
          :text="action.confirmation.text"
          @confirm="submitConfirm(action, index)"
          @cancel="visible[index] = false"
        />
      </b-dropdown-item>
    </b-dropdown>
    <div class="d-lg-none">
      <button :class="buttonClasses" @click.stop="onOpen">
        <slot name="button-custom-content" v-bind:item="item">
          <i
            class="icon-more-vertical btn btn-sm btn-square-sm default-icon"
            role="button"
          ></i>
        </slot>
      </button>
      <responsive-modal v-model="modalOptions" class="d-lg-none">
        <slot name="modal-header-area" />
        <div
          v-for="(action, index) in actions"
          :key="index"
          @click.stop="onClickItem(action, index)"
          class="my-3"
        >
          <hr v-if="action.text.toLowerCase().match('excluir')" />
          <small
            class="d-flex align-items-center mb-6 mb-lg-0"
            :class="action.class"
          >
            <i v-if="action.icon" class="mr-3" :class="action.icon"></i>
            <span v-html="action.text"></span>
          </small>
          <confirmation
            v-if="action.confirmation.enable"
            iconType="warning"
            :type="action.confirmation.type"
            title="Aviso"
            cancelButtonText="Cancelar"
            :showCancelButton="action.confirmation.showCancelButton"
            v-model="visible[index]"
            :newDesign="action.confirmation.newDesign"
            :confirmButtonClass="action.confirmation.submitButtonClass"
            :confirmButtonText="action.confirmation.submitText"
            :text="action.confirmation.text"
            @confirm="submitConfirm(action, index)"
            @cancel="visible[index] = false"
          />
        </div>
      </responsive-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    left: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: false
    },
    toggleClass: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    },
    buttonClasses: {
      type: [String, Object],
      default: "btn btn-sm btn-square-sm p-5"
    },
    actions: {
      type: Array,
      default: () => [
        {
          icon: "fa-solid fa-pen",
          text: "Editar",
          class: "",
          event: "edit"
        }
      ]
    }
  },
  data() {
    return {
      modalOptions: false,
      visible: {
        ...Array(this.actions.length).fill(false)
      }
    };
  },
  methods: {
    onOpen(e) {
      e.preventDefault();
      this.modalOptions = true;
    },
    onClickItem(action, index) {
      if (action.confirmation.enable) {
        this.visible[index] = true;
        return;
      }

      if (action.eventOnClick) {
        action.eventOnClick();
      } else {
        this.$emit(action.event);
      }
      this.modalOptions = false;
    },
    submitConfirm(action, index) {
      if (action.eventOnClick) {
        action.eventOnClick();
      } else {
        this.$emit(action.event);
      }

      this.visible[index] = false;
      this.modalOptions = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-dropdown {
  ::v-deep .dropdown {
    outline: none;
  }

  ::v-deep .dropdown-item {
    padding: 2px 16px;
    font-weight: normal !important;
    color: var(--l-neutral-7);

    i {
      font-size: 16px !important;
    }

    small {
      display: grid;
      grid-template-columns: 24px 1fr;

      i {
        font-size: 20px;

        &.fa-link,
        &.fa-solid {
          font-size: 16px;
        }
        @media screen and (max-width: 991px) {
          font-size: 24px;
        }
      }
    }
  }

  ::v-deep .dropdown-item:hover {
    color: #5576ec !important;
    background: transparent;
  }

  ::v-deep .dropdown-item:focus {
    opacity: 60%;
  }

  .default-icon {
    color: #393444;
    padding: 0;

    &:hover {
      background: #393444;
      color: white;
    }
  }
}
</style>
